import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../icon';

/**
 * Tag.Colorable
 */

class Colorable extends Component {
  static propTypes = {
    /**
     * 标签类名前缀,提供给二次开发者用
     * @default next-
     */
    prefix: PropTypes.string,
    /**
     * color 标签的颜色，可选值 'red'、'green'、'yellow'、'blue'、'gray'
     */
    color: PropTypes.string,
    /**
     * size 标签尺寸
     */
    size: PropTypes.string,
    /**
     * type 标签的类型，可选值 'normal'、'closeable'、'link'
     */
    type: PropTypes.oneOf(['normal', 'closeable', 'link']),
    /**
     * icon 左侧图标
     */
    icon: PropTypes.string,
    /**
     * value 表示 tag 的值
     */
    value: PropTypes.any,
    /**
     * onClose 点击回调，只有当 type=closeable 时有
     */
    onClose: PropTypes.func,
    className: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    children: PropTypes.any,
    rtl: PropTypes.bool,
  };

  static defaultProps = {
    prefix: 'next-',
    size: 'small',
    color: 'blue',
    type: 'normal',
    target: '_self',
  };

  render() {
    const {
      prefix,
      className,
      size,
      onClose,
      type,
      color,
      children,
      icon,
      rtl,
      value,
      href,
      target,
    } = this.props;
    const classNames = classnames(
      `${prefix}color-tag`,
      `${prefix}color-tag-${color}`,
      className,
      {
        pointer: type === 'closeable',
      },
      {
        interactive: type === 'closeable' || type === 'link',
      },
      {
        [`${prefix}color-s-tag`]: size === 'small',
      },
    );

    const leftCls =
      size === 'small' ? `${prefix}color-s-tag-left-icon` : `${prefix}color-tag-left-icon`;
    const rightCls =
      size === 'small' ? `${prefix}color-s-tag-right-icon` : `${prefix}color-tag-right-icon`;
    const linkCls =
      size === 'small'
        ? `${prefix}color-s-tag-right-link-icon`
        : `${prefix}color-tag-right-link-icon`;

    if (type !== 'link') {
      return (
        <span className={classNames} dir={rtl ? 'rtl' : undefined}>
          {icon && <Icon type={icon} className={leftCls} />}
          <span className={`${prefix}color-tag-children`}>{children}</span>
          {type === 'closeable' ? (
            <Icon
              type="remove"
              onClick={onClose ? () => onClose(value) : () => {}}
              className={rightCls}
            />
          ) : null}
        </span>
      );
    } else {
      return (
        <a className={classNames} dir={rtl ? 'rtl' : undefined} href={href} target={target}>
          {icon && <Icon type={icon} className={`${prefix}color-tag-left-icon`} />}
          <span className={`${prefix}color-tag-children`}>{children}</span>
          <Icon type="chevron-right-s" className={linkCls} />
        </a>
      );
    }
  }
}

export default Colorable;
